export class DataShareIntegrationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lastSyncedAt",
            "baseName": "lastSyncedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "msg",
            "baseName": "msg",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataShareIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
